export const RegisterRenameModalMobileConfig = {
  panelClass: 'no-padding',
  autoFocus: false,
  width: '100%',
}

export const RegisterRenameModalDesktopConfig = {
  panelClass: 'no-padding',
  autoFocus: false,
  minWidth: '440px',
  disableClose: true,
}
